import { Component, input } from '@angular/core';
import { DropdownModule } from 'primeng/dropdown';
import { IndicatorsService } from '../../services/indicators.service';
import { ToastrService } from 'ngx-toastr';
import { DirectionService } from '../../services/direction.service';
import { SocketService } from '../../services/socket.service';
import { StrategyService } from '../../services/strategy.service';
import { TableModule, TableRowCollapseEvent, TableRowExpandEvent } from 'primeng/table';
import { TranslateModule } from '@ngx-translate/core';
import { TagModule } from 'primeng/tag';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Strategy } from '../../interfaces/models/strategy.model';
import { DialogModule } from 'primeng/dialog';
import { WebViewerComponent } from '../../webviewer/webviewer.component';
import { SignalRService } from '../../services/signal-r.service';
import { NotificationTypesEnum } from '../../interfaces';
import { NotificationService } from '../../services/notification.service';
import { InputTextModule } from 'primeng/inputtext';


import { NavTitlePipe } from '../../pipes/nav-title.pipe';

@Component({
  selector: 'app-indicators-file-audtior',
  standalone: true,
  imports: [
    NavTitlePipe,
    DialogModule,
    WebViewerComponent,
    DropdownModule,
    CommonModule,
    FormsModule,
    RadioButtonModule,
    RouterModule,
    TooltipModule,
    TagModule,
    InputTextModule,
    ButtonModule, TranslateModule, TableModule],
  templateUrl: './indicators-file-audtior.component.html',
  styleUrl: './indicators-file-audtior.component.scss'
})
export class IndicatorsFileAudtiorComponent {
  dir!: 'rtl' | 'ltr';
  locale!: "ar" | "en";
  indicators!: any[];
  assessmentModal = false;
  selectedFile!: any;
  selectedStrategyId = 0;
  selectedStrategy = {} as Strategy;
  strategyOptions = [] as { name: string, strategyId: number }[];
  constructor(
    private toastr: ToastrService,
    private socketService: SocketService,
    private directionService: DirectionService,
    private indicatorService: IndicatorsService,
    private strategyService: StrategyService,
    private route: ActivatedRoute,
    private signalrService: SignalRService,
    private notificationService: NotificationService
  ) {

  }

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      const strategyId = params['strategyId'];
      const data = params['data'];
    });
    this.strategyService.RawStrategies$.subscribe((strategies: Strategy[]) => {
      if (this.selectedStrategyId == 0) {
        let defultStrategy = strategies.find(x => x.is_default);
        this.selectedStrategyId = defultStrategy?.id || 0;
        this.selectedStrategy = defultStrategy as Strategy;
        this.strategyService.setStrategyIdfn(defultStrategy?.id || 0)
        this.strategyService.setSelectedPillarIdfn(0)
      }
      else {
        let Strategy = strategies.find(x => x.id == this.selectedStrategyId);
        this.selectedStrategy = Strategy as Strategy;
        this.strategyService.setStrategyIdfn(this.selectedStrategyId)
        this.strategyService.setSelectedPillarIdfn(0)
      }
      this.indicatorService.getIndicatorsFileAuditor(this.selectedStrategyId).subscribe((response: any) => {
        this.indicators = response['data'].indicators;
        this.filteredIndicators = this.indicators;

      })
      this.strategyOptions = strategies.map((x) => ({ name: x.name, strategyId: x.id }))
    })

    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;

      this.locale = dir == "rtl" ? "ar" : "en";
    })

  }









  getFileIcon(type: string) {
    switch (type) {
      case 'image/jpeg':
      case 'image/png':
        return "fa-solid fa-file-image";
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        return "fa-solid fa-file-word";
      case 'application/pdf':
        return "fa-solid fa-file-pdf";
      case 'video/mp4':
      case 'video/x-msvideo':
      case 'video/quicktime':
      case 'video/x-matroska':
        return "fa-solid fa-file-video";
      default:
        return "fa-solid fa-file";
    }
  }
  assessOutput() {
    this.indicatorService.reviewAuditIndicatorFile(this.selectedStrategyId, { ... this.selectedFile, fileType: this.selectedFile.entityType }).subscribe((response: any) => {
      this.assessmentModal = false;
      const ParentIndicator = this.indicators.find(x => x.id == this.selectedFile.project_id)
      if (ParentIndicator) {
        const mappedFiles = ParentIndicator.files.map((x: any) => x.id == this.selectedFile.id ? { ...this.selectedFile } : x)
        ParentIndicator.files = mappedFiles
        this.indicators = this.indicators.map((x: any) => x.id == this.selectedFile.project_id ? { ...ParentIndicator } : x)

      }
      this.signalrService.reconnectIfDisconnected();
      this.notificationService.pushAuditRequest(
        +this.selectedStrategyId, {
        id: +this.selectedFile.id,
        parentEntityId: +this.selectedFile.parentEntityId,
        subEntityId: +this.selectedFile.subEntityId,
        type: NotificationTypesEnum.outcome_proof_audit_response
      },
        this.locale
      )
      this.toastr.success(response['data']['message'])
    })
  }

  openAssessmentModal(file: any) {
    console.log("#selectedFile#", file);
    this.assessmentModal = true;
    this.selectedFile = { ...file, comments: file.comments.trim() };
  }

  closeAssessmentModal() {
    this.assessmentModal = false;
    this.selectedFile = null;
  }
  MediaFileStatusEnum = {
    pending: 'pending',
    approved: 'approved',
    rejected: 'rejected'
  };
  FileStatusValues = {
    pending: "قيد المراجعة",
    approved: "معتمد",
    rejected: "مرفوض"
  };

  onRowExpand(event: TableRowExpandEvent) {
  }

  onRowCollapse(event: TableRowCollapseEvent) {
  }
  strategyOptionsChange() {
    this.strategyService.getStrategyById(this.selectedStrategyId.toString()).subscribe((strategy: any) => {
      this.selectedStrategy = strategy['data']['strategy'] as Strategy;
      this.indicatorService.getIndicatorsFileAuditor(this.selectedStrategyId).subscribe((response: any) => {
        console.log('response', response);
        this.indicators = response['data'].indicators;
      })
    })
    this.strategyService.setStrategyIdfn(this.selectedStrategyId)
    this.socketService.setRefreshNotification(this.selectedStrategyId)
  }

  isFileViewer = false;

  openFileViewer(file: any) {
    this.selectedFile = file;
    console.log("selected file", this.selectedFile);
    this.isFileViewer = true
  }
  downloadFile(file: any) {
    console.log("selected file", this.selectedFile);
    this.indicatorService.downloadOutcomeProof(this.selectedStrategyId, file.indicator_id, file.outcome_id, file.id).subscribe((x) => {
      console.log("blob", x);
      const blob = new Blob([x], { type: x.type });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = "";
      anchor.click();
      window.URL.revokeObjectURL(url);
    });
  }
  searchText = ''
  filteredIndicators = [] as any[];

  filterIndicators() {
    if (!this.searchText || !this.searchText.trim()) {
      // If search is empty, show all non-deleted indicators
      this.filteredIndicators = this.indicators;
    } else {
      const searchLower = this.searchText.trim().toLowerCase();
      this.filteredIndicators = this.indicators.filter((x: any) => {
        return x.name?.toLowerCase().includes(searchLower)
      }
      );
    }
  }
  
  goBack() {
    window.history.back();
  }

}




